import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SignInMain from "./SignInMain";

const SignIn = () => (
  <>
    <Header />
    <SignInMain />
    <Footer />
  </>
);

export default SignIn;
